function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = function (app, mod, build_number, og_card) {
  var recent_tweets = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var html = "\n\n<!DOCTYPE html>\n<html lang=\"en\" data-theme=\"dark\">\n\n<head>\n  <meta charset=\"utf-8\" />\n  <meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\" />\n  \n  <meta name=\"description\" content=\"".concat(app.browser.escapeHTML(mod.description), "\" />\n  <meta name=\"keywords\" content=\"").concat(mod.categories, "\"/>\n  <meta name=\"author\" content=\"Saito \uD83D\uDFE5\"/>\n  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1, shrink-to-fit=yes\" />\n\n  <meta name=\"mobile-web-app-capable\" content=\"yes\" />\n  <meta name=\"apple-mobile-web-app-capable\" content=\"yes\" />\n  <meta name=\"application-name\" content=\"saito.io redsquare\" />\n  <meta name=\"apple-mobile-web-app-title\" content=\"\uD83D\uDFE5 Saito P2P RedSquare\" />\n  <meta name=\"theme-color\" content=\"#FFFFFF\" />\n  <meta name=\"msapplication-navbutton-color\" content=\"#FFFFFF\" />\n  <meta name=\"apple-mobile-web-app-status-bar-style\" content=\"black-translucent\" />\n  <meta name=\"msapplication-starturl\" content=\"/index.html\" />\n\n  <meta name=\"twitter:card\" content=\"summary\" />\n  <meta name=\"twitter:site\" content=\"").concat(og_card.twitter, "\" />\n  <meta name=\"twitter:creator\" content=\"").concat(og_card.twitter, "\" />\n  <meta name=\"twitter:title\" content=\"").concat(app.browser.escapeHTML(og_card.title), "\" />\n  <meta name=\"twitter:url\" content=\"").concat(og_card.url, "\" />\n  <meta name=\"twitter:description\" content=\"").concat(app.browser.escapeHTML(og_card.description), "\" />\n  <meta name=\"twitter:image\" content=\"").concat(og_card.image, "\" />\n\n  <meta property=\"og:type\" content=\"website\" />\n  <meta property=\"og:title\" content=\"").concat(app.browser.escapeHTML(og_card.title), "\" />\n  <meta property=\"og:url\" content=\"").concat(og_card.url, "\" />\n  <meta property=\"og:description\" content=\"").concat(app.browser.escapeHTML(og_card.description), "\"/>\n  <meta property=\"og:site_name\" content=\"Saito\" />\n  <meta property=\"og:image\" content=\"").concat(og_card.image, "\"/>\n  <meta property=\"og:image:url\" content=\"").concat(og_card.image, "\"/>\n  <meta property=\"og:image:secure_url\" content=\"").concat(og_card.image, "\"/>\n\n  <link rel=\"icon\" sizes=\"192x192\" href=\"/saito/img/touch/pwa-192x192.png\" />\n  <link rel=\"apple-touch-icon\" sizes=\"192x192\" href=\"/saito/img/touch/pwa-192x192.png\" />\n  <link rel=\"icon\" sizes=\"512x512\" href=\"/saito/img/touch/pwa-512x512.png\" />\n  <link rel=\"apple-touch-icon\" sizes=\"512x512\" href=\"/saito/img/touch/pwa-512x512.png\" />\n\n  <link rel=\"stylesheet\" href=\"/saito/lib/font-awesome-6/css/fontawesome.min.css\" type=\"text/css\" media=\"screen\" />\n  <link rel=\"stylesheet\" href=\"/saito/lib/font-awesome-6/css/all.css\" type=\"text/css\" media=\"screen\" />\n  \n  <script data-pace-options='{ \"restartOnRequestAfter\" : false, \"restartOnPushState\" : false}' src=\"/saito/lib/pace/pace.min.js\"></script>\n  <link rel=\"stylesheet\" href=\"/saito/lib/pace/center-atom.css\">\n\n  <link rel=\"stylesheet\" type=\"text/css\" href=\"/saito/saito.css?v=").concat(build_number, "\" />\n\n  <title>Saito RedSquare</title>\n\n    <style type=\"text/css\">\n    /* css for fade-out bg effect while content is loading */\n    body::before {\n      content: \"\";\n      opacity: 1;\n      z-index: 160;\n      /*saito-header has z-index:15 */\n      position: absolute;\n      top: 0;\n      left: 0;\n      display: block;\n      height: 100vh;\n      width: 100vw;\n      /* hardcode bg colors used because saito-variables arent accessible here */\n      background-color: #1c1c23;\n      background-image: url('/saito/img/tiled-logo.svg');\n    }\n  </style>\n\n</head>\n<body></body>\n");
  html += "<script type=\"text/javascript\">\n  var active_module = '".concat(mod.returnSlug(), "';\n  if (!tweets) { \n    var tweets = [];\n  }\n");
  var _iterator = _createForOfIteratorHelper(recent_tweets),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var tweet = _step.value;
      html += " tweets.push(`".concat(tweet, "`);\n");
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  html += "\n /*".concat(recent_tweets.length, " cached tweets from server*/ </script>\n\n\n<script type=\"text/javascript\" src=\"/saito/saito.js?build=").concat(build_number, "\"></script>\n</html>");
  return html;
};